export default "__VITE_ASSET__CAnG058l__"